import React, { useState, useEffect } from "react";
import "dayjs/locale/ru";
import dayjs from "dayjs";
import {
  currencies,
  orderTypes,
  packageTypes,
  loadTypes,
  shippingType,
  shippingTypesCls,
} from "../search/constants";
import { transportCategories, transportBodyTypes } from "../search/categories";
import * as orderStatus from "../constants/status";

const loadType = (type) => {
  if (!type) {
    return "";
  }
  const loadType = loadTypes.find((c) => +c.value === +type);
  if (!loadType) {
    return "";
  }
  return loadType.label;
};

const packageType = (type) => {
  if (!type) {
    return "";
  }
  const packageType = packageTypes.find((c) => +c.value === +type);
  if (!packageType) {
    return null;
  }
  return packageType.label;
};

const transportType = (type) => {
  if (!type) {
    return "";
  }
  const transportType = transportCategories.find((c) => +c.value === +type);
  if (!transportType) {
    return null;
  }
  return transportType;
};

const bodyType = (type) => {
  if (!type) {
    return "";
  }
  const transportType = transportBodyTypes.find((c) => +c.id === +type);
  if (!transportType) {
    return null;
  }
  return transportType.name;
};

const orderType = (type) => {
  if (!type) {
    return "";
  }
  const orderType = orderTypes.find((c) => +c.value === +type);
  if (!orderType) {
    return "";
  }
  return orderType.label;
};

const currency = (type) => {
  if (!type) {
    return "";
  }
  const currency = currencies.find((c) => +c.value === +type);
  if (!currency) {
    return "";
  }
  return currency.label;
};

const Order = ({ order, onSelectOrder, selectedOrders }) => {
  // Always use UUID for consistent selection with OrderList component
  const isSelected = selectedOrders
    ? selectedOrders.includes(order.uuid)
    : false;

  return (
    <div className="transport suggest-order">
      <div
        className={
          isSelected
            ? "suggest-order__overlay active"
            : "suggest-order__overlay"
        }
      >
        <div
          className="suggest-order__overlay__select"
          onClick={() => onSelectOrder(order)}
        >
          <div className="suggest-order__overlay__select__icon" />
          <div className="suggest-order__overlay__select__text">
            {isSelected ? "Отменить" : "Выбрать"}
          </div>
        </div>
      </div>
      <div className="transport__wrapper">
        <div className="transport__driver pd-25">
          <div className="transport__date">
            <div className="transport__date__month">
              {dayjs(order.created_at).locale("ru").format("MMMM")}
            </div>
            <div className="transport__date__day">
              {dayjs(order.created_at).locale("ru").format("DD")}
            </div>
          </div>
          <div className="transport__driver__info">
            <div className="transport__driver__info__id">ID {order.uuid}</div>
            <div className="transport__driver__info__name">
              {order.contacts.company_name || order.contacts.contact_name}
            </div>
          </div>
          <div className="transport__driver__rating">
            <div className="transport__driver__rating__icon" />
            <div className="transport__driver__rating">5.0</div>
          </div>
        </div>
        <div className="transport__destinations pd-25">
          <div className="transport__destinations__left">
            {order.from_address.split(", ")[0] !== order.from_country && <div className="transport__destination__city">
              {order.from_address.split(", ")[0]}
            </div>}
            {order.from_address.split(", ")[0] === order.from_country && <div className="transport__destination__city">
              &nbsp;
            </div>}
            <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--from">
              <div className="transport__destination__icon transport__destination__icon--from">
                A
              </div>
            </div>
            <div className="transport__destination__country">
              <strong>{order.from_country_code}</strong>, {order.from_country}
            </div>
          </div>
          <div className="transport__destinations__middle">
            <div className="transport__destinations__middle__border" />
            <div className="transport__destinations__middle__distance">
              <div className="transport__destinations__middle__distance__icon" />
              {order.distance}
            </div>
          </div>
          <div className="transport__destinations__right">
            {order.to_address.split(", ")[0] !== order.to_country && <div className="transport__destination__city">
              {order.to_address.split(", ")[0]}
            </div>}
            {order.to_address.split(", ")[0] === order.to_country && <div className="transport__destination__city">
              &nbsp;
            </div>}
            <div className="transport__destination__icon__wrapper transport__destination__icon__wrapper--to">
              <div className="transport__destination__icon transport__destination__icon--to">
                B
              </div>
            </div>
            <div className="transport__destination__country">
              <strong>{order.to_country_code}</strong>, {order.to_country}
            </div>
          </div>
        </div>
        <div className="transport__price pd-25">
          <div className="transport__price__icon" />
          {order.price && (
            <span>
              <strong>
                {order.price} {currency(order.currency || null)}
              </strong>
              &nbsp;
              <span style={{ color: "#72809D", fontSize: "14px" }}>
                &bull; {order.nds ? "с НДС" : "без НДС"}
              </span>
            </span>
          )}
          {!order.price && <strong>Ждем предложения</strong>}
        </div>
        <div
          className={`transport__price transport__type pd-25 ${shippingTypesCls[order.type_of_transportation]}`}
        >
          <div className="transport__price__icon"></div>
          <strong>{shippingType(order.type_of_transportation)}</strong>
        </div>
        <div
          className="transport__badges pd-25"
          style={{ borderBottom: "none", marginBottom: 0 }}
        >
          <div className="transport__badge transport__type">
            {order.item.weight} тонн
          </div>
          <div className="transport__badge transport__type">
            {order.item.volume}м<sup>3</sup>
          </div>
          {order.item.type && (
            <div className="transport__badge transport__type">
              {orderType(order.item.type)}
            </div>
          )}
          {order.package_type && (
            <div className="transport__badge transport__type">
              {packageType(order.package_type)}
            </div>
          )}
          {transportType(order.transport_category) && (
            <div
              className={`transport__badge transport__category transport__type transport__type2 ${transportType(order.transport_category).className}`}
            >
              {bodyType(order.transport_body_type)}
            </div>
          )}
          {!!order.temperature_min && (
            <div className="transport__badge transport__type">
              {order.temperature_min}°C до {order.temperature_max}°C
            </div>
          )}
          {order.load_type &&
            order.load_type.length > 0 &&
            order.load_type.map((item) => {
              return (
                <div key={item} className="transport__badge transport__type">
                  {loadType(item)}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Order;
